import { useLocation } from 'react-router-dom';

export function useLocationHash() {
  const { hash } = useLocation();
  return hash === '' ? undefined : hash.substr(1);
}
